module.exports = __webpack_public_path__ + "img/resize.bfb8c608.webp";